/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNetworking = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 2v8h-3v1h6v3h3v8h-8v-8h3v-1H7v1h3v8H2v-8h3v-3h6v-1H8V2zM8 16H4v4h4zm12 0h-4v4h4zM14 4h-4v4h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNetworking as Networking };
